import React from "react";
import {
  Button,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";

type Props = {
  open: boolean;
  isEdit: boolean;
  busy: boolean;
  title: string;
  description: string;
  canSubmit: boolean;
  onClose: () => void;
  onChangeTitle: (value: string) => void;
  onChangeDescription: (value: string) => void;
  onSubmit: () => Promise<void>;
};

export default function WorkOrderTaskFormModal({
  open,
  isEdit,
  busy,
  title,
  description,
  canSubmit,
  onClose,
  onChangeTitle,
  onChangeDescription,
  onSubmit,
}: Props) {
  return (
    <Modal isOpen={open} toggle={() => !busy && onClose()} centered>
      <ModalHeader toggle={() => !busy && onClose()}>
        {isEdit ? "Edit task" : "Add task"}
      </ModalHeader>
      <ModalBody>
        <Label className="form-label mb-1">Task title</Label>
        <Input
          type="text"
          value={title}
          onChange={(e) => onChangeTitle(e.target.value)}
          placeholder="Eg. Install wiring and test panel"
          disabled={busy}
        />
        <Label className="form-label mt-3 mb-1">Description (optional)</Label>
        <Input
          type="textarea"
          rows={8}
          value={description}
          onChange={(e) => onChangeDescription(e.target.value)}
          placeholder="Add task description"
          disabled={busy}
        />
      </ModalBody>
      <ModalFooter>
        <Button color="light" onClick={onClose} disabled={busy}>
          Cancel
        </Button>
        <Button
          color={isEdit ? "success" : "primary"}
          onClick={() => void onSubmit()}
          disabled={busy || !canSubmit}
        >
          {busy ? "Saving..." : isEdit ? "Save changes" : "Add task"}
        </Button>
      </ModalFooter>
    </Modal>
  );
}
